import React from 'react';
import { Shield, Award, Target, TrendingUp } from 'lucide-react';
import { cyberAchievements } from '../data/mock';
import { Card } from './ui/card';
import { Badge } from './ui/badge';

const CyberSecurity = () => {
  return (
    <section id="cybersecurity" className="section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            <Shield className="inline mr-2" size={32} />
            Network Security & Achievements
          </h2>
          <div className="section-underline"></div>
          <p className="section-description">
            Passionate about cybersecurity with hands-on experience in penetration testing and security research
          </p>
        </div>
        <div className="cyber-content">
          <div className="cyber-stats">
            <Card className="cyber-stat-card">
              <div className="cyber-stat-icon">
                <Target size={32} />
              </div>
              <div className="cyber-stat-value">{cyberAchievements.tryhackme.roomsCompleted}</div>
              <div className="cyber-stat-label">TryHackMe Rooms</div>
              <div className="cyber-stat-notable">
                {cyberAchievements.tryhackme.notableRooms.map((room, idx) => (
                  <Badge key={idx} variant="outline" className="notable-room-badge">
                    {room}
                  </Badge>
                ))}
              </div>
            </Card>
            <Card className="cyber-stat-card">
              <div className="cyber-stat-icon">
                <Award size={32} />
              </div>
              <div className="cyber-stat-value">{cyberAchievements.tryhackme.badges}</div>
              <div className="cyber-stat-label">Security Badges</div>
              <div className="cyber-stat-description">
                Earned in various cybersecurity domains
              </div>
            </Card>
            <Card className="cyber-stat-card">
              <div className="cyber-stat-icon">
                <TrendingUp size={32} />
              </div>
              <div className="cyber-stat-value">3+</div>
              <div className="cyber-stat-label">Years Experience</div>
              <div className="cyber-stat-description">
                Network security & penetration testing
              </div>
            </Card>
          </div>
          <div className="cyber-skills">
            <h3 className="cyber-skills-title">Security Expertise</h3>
            <div className="cyber-skills-grid">
              {cyberAchievements.tryhackme.skills.map((skill, idx) => (
                <div key={idx} className="cyber-skill-item">
                  <Shield size={18} className="cyber-skill-icon" />
                  <span>{skill}</span>
                </div>
              ))}
            </div>
            <div className="cyber-areas">
              <h4 className="cyber-areas-title">Areas of Focus</h4>
              <div className="cyber-areas-list">
                {cyberAchievements.expertise.map((area, idx) => (
                  <Badge key={idx} className="cyber-area-badge">
                    {area}
                  </Badge>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CyberSecurity;